export default "__VITE_ASSET__E9EbBuz6__"